export default __webpack_public_path__ + "static/media/bootstrap2.6b0e63d3.png";